import React, { useEffect } from 'react'
import { useDataChange } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let setDisplayPatientOptions = useDataChange({
    context: 'display_patient_options',
    viewPath: props.viewPath,
  })

  // close patient overlay
  useEffect(() => {
    setDisplayPatientOptions(true)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <View {...props} />
}
